export default {
  dual1: [
    {
      percent: '55.73%',
      color: '#8cbbd3',
    },
    {
      percent: '99.92%',
      color: '#e47bac',
    },
  ],
  dual2: [
    {
      percent: '53.22%',
      color: '#5bb89a',
    },
    {
      percent: '96.36%',
      color: '#e47bac',
    },
  ],
  dual3: [
    {
      percent: '31.29%',
      color: '#00a9bc',
    },
    {
      percent: '92.37%',
      color: '#f7a6a6',
    },
  ],
  dual4: [
    {
      percent: '61.77%',
      color: '#6184e7',
    },
    {
      percent: '94.39%',
      color: '#e48c7b',
    },
  ],
  dual5: [
    {
      percent: '66.77%',
      color: '#ba80ff',
    },
    {
      percent: '91.82%',
      color: '#d8a46a',
    },
  ],
  dual6: [
    {
      percent: '61.91%',
      color: '#fdc251',
    },
    {
      percent: '97.25%',
      color: '#fdb0f1',
    },
  ],
  dual7: [
    {
      percent: '57.29%',
      color: '#21ba4c',
    },
    {
      percent: '100%',
      color: '#daa46d',
    },
  ],
  multi1: [
    {
      percent: '0%',
      color: '#82beff',
    },
    {
      percent: '47.21%',
      color: '#a6b4f7',
    },
    {
      percent: '73.75%',
      color: '#5bb89a',
    },
    {
      percent: '91.26%',
      color: '#21ba4c',
    },
  ],
  multi2: [
    {
      percent: '49.42%',
      color: '#fdc251',
    },
    {
      percent: '66.01%',
      color: '#fdb0f1',
    },
    {
      percent: '80.01%',
      color: '#a6b4f7',
    },
    {
      percent: '95.04%',
      color: '#73b5ff',
    },
  ],
  multi3: [
    {
      percent: '51.59%',
      color: '#00a9bc',
    },
    {
      percent: '66.62%',
      color: '#8cbbd3',
    },
    {
      percent: '83.21%',
      color: '#a1e696',
    },
    {
      percent: '99.68%',
      color: '#e3d1df',
    },
  ],
  multi4: [
    {
      percent: '36.61%',
      color: '#21ba4c',
    },
    {
      percent: '62.24%',
      color: '#fdb0f1',
    },
    {
      percent: '73.29%',
      color: '#e6dd96',
    },
    {
      percent: '99.65%',
      color: '#e3d1df',
    },
  ],
  multi5: [
    {
      percent: '45.26%',
      color: '#d5cc0a',
    },
    {
      percent: '64.05%',
      color: '#f7a6a6',
    },
    {
      percent: '79.5%',
      color: '#c7d08f',
    },
    {
      percent: '99.7%',
      color: '#e3d1df',
    },
  ],
  multi6: [
    {
      percent: '42.19%',
      color: '#e5e230',
    },
    {
      percent: '77.6%',
      color: '#84d2df',
    },
    {
      percent: '100%',
      color: '#c6afe1',
    },
  ],
  multi7: [
    {
      percent: '45.26%',
      color: '#fdc251',
    },
    {
      percent: '62.39%',
      color: '#fdb0f1',
    },
    {
      percent: '79.47%',
      color: '#f7a6a6',
    },
    {
      percent: '99.7%',
      color: '#ff7373',
    },
  ],
  multi8: [
    {
      percent: '0.85%',
      color: '#ff0000',
    },
    {
      percent: '51.62%',
      color: '#ffb18c',
    },
    {
      percent: '81.31%',
      color: '#ffc600',
    },
    {
      percent: '96.64%',
      color: '#f4d4e1',
    },
  ],
  multi9: [
    {
      percent: '0%',
      color: '#01d054',
    },
    {
      percent: '27.08%',
      color: '#84d2df',
    },
    {
      percent: '52.08%',
      color: '#c1dd6c',
    },
    {
      percent: '69%',
      color: '#e5e230',
    },
    {
      percent: '85.94%',
      color: '#f2c79a',
    },
    {
      percent: '100%',
      color: '#fab6b6',
    },
  ],
  multi10: [
    {
      percent: '6.87%',
      color: '#00b99b',
    },
    {
      percent: '26.59%',
      color: '#a4bfff',
    },
    {
      percent: '35.26%',
      color: '#c4c1a6',
    },
    {
      percent: '48.67%',
      color: '#ffc600',
    },
    {
      percent: '85.74%',
      color: '#ff77ab',
    },
  ],
  multi11: [
    {
      percent: '22.14%',
      color: '#83da00',
    },
    {
      percent: '33.31%',
      color: '#00d053',
    },
    {
      percent: '53.17%',
      color: '#84d2df',
    },
    {
      percent: '74.89%',
      color: '#e6dd96',
    },
    {
      percent: '84.19%',
      color: '#f4d4e1',
    },
  ],
  multi12: [
    {
      percent: '10.19%',
      color: '#fdb0f1',
    },
    {
      percent: '33.82%',
      color: '#e5e230',
    },
    {
      percent: '62.8%',
      color: '#84d2df',
    },
    {
      percent: '72.71%',
      color: '#c6afe1',
    },
    {
      percent: '86.44%',
      color: '#01d054',
    },
  ],
};
